import {setPanelSurveyIsValid_actionType, resetPanel} from "../constants"

const initialState = false
const panelSurveyIsValid = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case setPanelSurveyIsValid_actionType:
            return state = payload
        case resetPanel:
            return state = initialState
        default:
            return state
    }
}

export default panelSurveyIsValid 